<template>
  <div class="bg-background">
    <TheHeader />
    <div class="pt-16 sm:pt-20 md:pt-24 lg:pt-28">
      <SpecialOfferNotification 
        v-if="showAlert" 
        @close="showAlert = false"
        :dark="false"
        :fixed="true"
      />
      <SpecialNotificationUsers
        :dark="false"
        :fixed="true"
      />
    </div>
    <main :class="[
      'min-h-[60vh] flex items-center justify-center text-center px-4 pb-0',
      showAlert ? 'pt-20 sm:pt-24 md:pt-28' : 'pt-20 sm:pt-24 md:pt-32'
    ]">
      <div>
        <h1 class="text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-medium max-w-4xl mx-auto leading-tight mb-4 md:mb-6 animate-fade-in">
          Доступ к Midjourney, Cursor, Perplexity и другим зарубежным сервисам
<!--          <span class="blinking-cursor">|</span>-->
        </h1>
        <p class="text-gray-400 text-sm sm:text-base md:text-lg lg:text-xl max-w-2xl mx-auto mb-6 md:mb-8 animate-stagger-1">
          Оплачивайте любые интернет-сервисы с помощью Carddy
        </p>
        <div class="flex flex-col sm:flex-row flex-wrap justify-center gap-3 sm:gap-4 mb-6 animate-stagger-2">
          <router-link to="/signup" v-if="count==0" class="bg-white text-black px-5 py-2 md:px-8 md:py-3 rounded-full font-medium inline-block hover:bg-gray-100 transition-colors">
            Попробовать Carddy
          </router-link>
          <router-link to="/dashboard" v-if="count==1" class="bg-white text-black px-5 py-2 md:px-8 md:py-3 rounded-full font-medium inline-block hover:bg-gray-100 transition-colors">
            Личный кабинет
          </router-link>
          <button @click="showHowItWorksModal = true" class="bg-transparent text-white px-5 py-2 md:px-8 md:py-3 rounded-full font-medium inline-block border border-gray-600 hover:border-white transition-colors mt-3 sm:mt-0">
            Как это работает?
          </button>
          <button @click="showAskQuestionModal = true" class="bg-transparent text-white px-5 py-2 md:px-8 md:py-3 rounded-full font-medium inline-block border border-gray-600 hover:border-white transition-colors mt-3 sm:mt-0">
            Задать вопрос
          </button>
        </div>
        
        <!-- Sales counter -->
        <div class="mb-8 animate-stagger-3">
          <div class="inline-flex flex-col sm:flex-row items-center bg-gray-800 bg-opacity-50 px-4 sm:px-6 py-3 rounded-full">
            <span class="text-3xl sm:text-4xl font-bold text-white sm:mr-2" ref="counter">{{ cards_counter }}</span>
            <span class="text-gray-300 text-sm sm:text-base mt-1 sm:mt-0">Пользователей уже получили доступ</span>
          </div>
        </div>
      </div>
    </main>
    
    <!-- Scrolling Icons Section -->
    <div class="py-4">
<!--      <p class="text-center text-gray-400 text-sm mb-2 animate-stagger-3">Trusted by leading companies worldwide</p>-->
      <ScrollingIcons />
    </div>
    
    <div id="features" class="scroll-mt-24">
      <FeatureCards />
    </div>
    
    <!-- Call to Action Section -->
    <div id="pricing" class="py-32 px-8 md:px-16 animate-fade-in-scroll scroll-mt-24">
      <div class="container mx-auto max-w-6xl">
        <div class="rounded-3xl p-10 md:p-16" style="background-color: #242527;">
          <div class="flex flex-col md:flex-row justify-between items-center gap-10">
            <div class="max-w-2xl">
              <h2 class="text-white text-3xl md:text-4xl lg:text-5xl font-normal mb-4">
                Сколько стоит доступ?
                <br/>
                <span class="text-gray-500 ">Почему именно такой курс?</span>
              </h2>
              <p class="text-gray-400 text-lg">
                Стоимость складывается исключительно из валютного курса, устанавливаемого банками-контрагентами, и размером транзакционных издержек.
              </p>
            </div>
            <div class="shrink-0">
              <a href="#" class="bg-white text-black px-8 py-5 rounded-full inline-flex flex-col items-center hover:bg-gray-100 transition-colors relative">
                <div class="flex items-center">
                  <span class="text-2xl md:text-3xl font-medium">{{ usd_amount }}$ = {{ input_sql.rub_amount }}₽</span>
                </div>
<!--                <span class="text-sm md:text-base font-medium mt-1">+100₽ за выпуск карты</span>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- FAQ Section -->
    <div id="faq" class="py-12 sm:py-16 px-4 sm:px-8 md:px-16 animate-fade-in-scroll">
      <div class="container mx-auto max-w-6xl">
        <div class="bg-white rounded-[30px] sm:rounded-[40px] p-6 sm:p-8 md:p-12">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
            <!-- Left Column -->
            <div>
              <h2 class="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 text-black">Часто задаваемые вопросы</h2>
              <p class="text-gray-600 mb-6">Если у вас остались вопросы, вы всегда можете обратиться в службу поддержки</p>
              <button @click="showAskQuestionModal = true" class="bg-gray-100 text-black px-6 py-3 rounded-full inline-flex items-center hover:bg-gray-200 transition-colors">
                Связаться с нами
                <font-awesome-icon icon="arrow-right" class="ml-2" />
              </button>
            </div>

            <!-- Right Column -->
            <div class="space-y-4 mt-6 md:mt-0">
              <div v-for="(question, index) in faqQuestions" :key="index" class="bg-gray-100 rounded-2xl overflow-hidden">
                <!-- Question Header -->
                <div 
                  class="p-4 flex justify-between items-center cursor-pointer hover:bg-gray-200 transition-colors duration-300"
                  @click="toggleFaq(index)"
                >
                  <span class="text-black font-medium text-sm sm:text-base pr-2">{{ question.text }}</span>
                  <div class="bg-black text-white rounded-full w-6 h-6 sm:w-8 sm:h-8 flex-shrink-0 flex items-center justify-center transition-all duration-500">
                    <font-awesome-icon 
                      icon="chevron-down" 
                      class="transition-transform duration-500 text-xs sm:text-sm" 
                      :class="{ 'rotate-180': question.isOpen }"
                    />
                  </div>
                </div>
                
                <!-- Answer Content (conditionally shown) -->
                <div 
                  class="px-4 text-gray-700 overflow-hidden transition-all duration-500 ease-in-out text-sm sm:text-base"
                  :style="{ maxHeight: question.isOpen ? '500px' : '0', opacity: question.isOpen ? 1 : 0, padding: question.isOpen ? '0 1rem 1rem 1rem' : '0 1rem' }"
                >
                  <p>{{ question.answer }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Blog Section -->
    <div id="blog" class="py-12 sm:py-16 px-4 sm:px-8 md:px-16 animate-fade-in-scroll">
      <div class="container mx-auto max-w-6xl">
        <div class="text-center mb-8 sm:mb-12">
          <h2 class="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 text-white">Блог</h2>
          <p class="text-gray-400 text-sm sm:text-base md:text-lg max-w-2xl mx-auto">Ознакомьтесь с информацией, советами и обновлениями от нашей команды экспертов.</p>
        </div>

        <!-- Blog Cards Row 1 -->
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 mb-4 sm:mb-6">
          <!-- Blog Card 1 -->


          <div class="bg-[#1c1c1c] rounded-3xl p-6 sm:p-8 transition-transform hover:scale-[1.02]">
            <div class="h-32 sm:h-40 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-xl mb-4 sm:mb-6 flex items-center justify-center">
              <i class="fas fa-credit-card text-white text-3xl sm:text-4xl"></i>
            </div>
            <h3 class="text-white text-lg sm:text-xl font-medium mb-2 sm:mb-3">Как оплатить Midjourney</h3>
            <p class="text-gray-400 mb-4 sm:mb-6 text-sm sm:text-base">Узнайте, как оплатить подписку Midjourney с помощью Carddy.</p>
            <div class="flex justify-between items-center">
              <span class="text-gray-500 text-xs sm:text-sm">3 Мая 2025</span>
              <router-link to="/midjourney" class="px-3 sm:px-4 py-1 sm:py-1.5 rounded-full border border-blue-500 text-white hover:bg-blue-500/10 transition text-xs sm:text-sm">
                Читать
              </router-link>
            </div>
          </div>

          <!-- Blog Card 2 -->
          <div class="bg-[#1c1c1c] rounded-3xl p-6 sm:p-8 transition-transform hover:scale-[1.02]">
            <div class="h-32 sm:h-40 bg-gradient-to-r from-green-500 to-teal-500 rounded-xl mb-4 sm:mb-6 flex items-center justify-center">
              <i class="fas fa-shield-alt text-white text-3xl sm:text-4xl"></i>
            </div>
            <h3 class="text-white text-lg sm:text-xl font-medium mb-2 sm:mb-3">Как оплатить PlayStation</h3>
            <p class="text-gray-400 mb-4 sm:mb-6 text-sm sm:text-base">Узнайте, как оплатить подписку PlayStation с помощью Carddy</p>
            <div class="flex justify-between items-center">
              <span class="text-gray-500 text-xs sm:text-sm">21 Февраля 2025</span>
              <router-link to="/playstation" class="px-3 sm:px-4 py-1 sm:py-1.5 rounded-full border border-blue-500 text-white hover:bg-blue-500/10 transition text-xs sm:text-sm">
                Читать
              </router-link>
            </div>
          </div>

          <!-- Blog Card 3 -->
          <div class="bg-[#1c1c1c] rounded-3xl p-6 sm:p-8 transition-transform hover:scale-[1.02]">
            <div class="h-32 sm:h-40 bg-gradient-to-r from-yellow-500 to-orange-500 rounded-xl mb-4 sm:mb-6 flex items-center justify-center">
              <i class="fas fa-globe text-white text-3xl sm:text-4xl"></i>
            </div>
            <h3 class="text-white text-lg sm:text-xl font-medium mb-2 sm:mb-3">Как дешево купить авиабилеты в Европу</h3>
            <p class="text-gray-400 mb-4 sm:mb-6 text-sm sm:text-base">Узнайте, как дешево купить авиабилеты в Европу с помощью Carddy.</p>
            <div class="flex justify-between items-center">
              <span class="text-gray-500 text-xs sm:text-sm">13 Декабря 2024</span>
              <router-link to="/travel" class="px-3 sm:px-4 py-1 sm:py-1.5 rounded-full border border-blue-500 text-white hover:bg-blue-500/10 transition text-xs sm:text-sm">
                Читать
              </router-link>
            </div>
          </div>
        </div>

        <!-- Blog Cards Row 2 -->
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 mb-4 sm:mb-6">
          <!-- Blog Card 1 -->
          <div class="bg-[#1c1c1c] rounded-3xl p-6 sm:p-8 transition-transform hover:scale-[1.02]">
            <div class="h-32 sm:h-40 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-xl mb-4 sm:mb-6 flex items-center justify-center">
              <i class="fas fa-credit-card text-white text-3xl sm:text-4xl"></i>
            </div>
            <h3 class="text-white text-lg sm:text-xl font-medium mb-2 sm:mb-3">Как оплатить SurfShark</h3>
            <p class="text-gray-400 mb-4 sm:mb-6 text-sm sm:text-base">Узнайте, как оплатить подписку SurfShark с помощью Carddy.</p>
            <div class="flex justify-between items-center">
              <span class="text-gray-500 text-xs sm:text-sm">27 Ноября 2024</span>
              <router-link to="/surfshark" class="px-3 sm:px-4 py-1 sm:py-1.5 rounded-full border border-blue-500 text-white hover:bg-blue-500/10 transition text-xs sm:text-sm">
                Читать
              </router-link>
            </div>
          </div>

          <!-- Blog Card 2 -->
          <div class="bg-[#1c1c1c] rounded-3xl p-6 sm:p-8 transition-transform hover:scale-[1.02]">
            <div class="h-32 sm:h-40 bg-gradient-to-r from-green-500 to-teal-500 rounded-xl mb-4 sm:mb-6 flex items-center justify-center">
              <i class="fas fa-shield-alt text-white text-3xl sm:text-4xl"></i>
            </div>
            <h3 class="text-white text-lg sm:text-xl font-medium mb-2 sm:mb-3">Как оплатить и заказать товары из iHerb</h3>
            <p class="text-gray-400 mb-4 sm:mb-6 text-sm sm:text-base">Узнайте, как оплатить заказы из iHerb с помощью Carddy.</p>
            <div class="flex justify-between items-center">
              <span class="text-gray-500 text-xs sm:text-sm">9 Сентября 2024</span>
              <router-link to="/iherb" class="px-3 sm:px-4 py-1 sm:py-1.5 rounded-full border border-blue-500 text-white hover:bg-blue-500/10 transition text-xs sm:text-sm">
                Читать
              </router-link>
            </div>
          </div>

          <!-- Blog Card 3 -->
          <div class="bg-[#1c1c1c] rounded-3xl p-6 sm:p-8 transition-transform hover:scale-[1.02]">
            <div class="h-32 sm:h-40 bg-gradient-to-r from-yellow-500 to-orange-500 rounded-xl mb-4 sm:mb-6 flex items-center justify-center">
              <i class="fas fa-globe text-white text-3xl sm:text-4xl"></i>
            </div>
            <h3 class="text-white text-lg sm:text-xl font-medium mb-2 sm:mb-3">Как добавить карту в GooglePlay</h3>
            <p class="text-gray-400 mb-4 sm:mb-6 text-sm sm:text-base">Узнайте, как добавить карту в Google Play с помощью Carddy.</p>
            <div class="flex justify-between items-center">
              <span class="text-gray-500 text-xs sm:text-sm">15 Июля 2024</span>
              <router-link to="/googleplay" class="px-3 sm:px-4 py-1 sm:py-1.5 rounded-full border border-blue-500 text-white hover:bg-blue-500/10 transition text-xs sm:text-sm">
                Читать
              </router-link>
            </div>
          </div>
        </div>

        <!-- Blog Cards Row 3 -->
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 mb-4 sm:mb-6">
          <!-- Blog Card 1 -->
          <div class="bg-[#1c1c1c] rounded-3xl p-6 sm:p-8 transition-transform hover:scale-[1.02]">
            <div class="h-32 sm:h-40 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-xl mb-4 sm:mb-6 flex items-center justify-center">
              <i class="fas fa-credit-card text-white text-3xl sm:text-4xl"></i>
            </div>
            <h3 class="text-white text-lg sm:text-xl font-medium mb-2 sm:mb-3">Как оплатить DropBox</h3>
            <p class="text-gray-400 mb-4 sm:mb-6 text-sm sm:text-base">Узнайте, как оплатить DropBox с помощью Carddy.</p>
            <div class="flex justify-between items-center">
              <span class="text-gray-500 text-xs sm:text-sm">22 Июня 2024</span>
              <router-link to="/dropbox" class="px-3 sm:px-4 py-1 sm:py-1.5 rounded-full border border-blue-500 text-white hover:bg-blue-500/10 transition text-xs sm:text-sm">
                Читать
              </router-link>
            </div>
          </div>

          <!-- Blog Card 2 -->
          <div class="bg-[#1c1c1c] rounded-3xl p-6 sm:p-8 transition-transform hover:scale-[1.02]">
            <div class="h-32 sm:h-40 bg-gradient-to-r from-green-500 to-teal-500 rounded-xl mb-4 sm:mb-6 flex items-center justify-center">
              <i class="fas fa-shield-alt text-white text-3xl sm:text-4xl"></i>
            </div>
            <h3 class="text-white text-lg sm:text-xl font-medium mb-2 sm:mb-3">Как оплатить подписку через PayPal</h3>
            <p class="text-gray-400 mb-4 sm:mb-6 text-sm sm:text-base">Узнайте, как оплатить подписку через PayPal с помощью Carddy.</p>
            <div class="flex justify-between items-center">
              <span class="text-gray-500 text-xs sm:text-sm">5 Мая 2024</span>
              <router-link to="/paypal" class="px-3 sm:px-4 py-1 sm:py-1.5 rounded-full border border-blue-500 text-white hover:bg-blue-500/10 transition text-xs sm:text-sm">
                Читать
              </router-link>
            </div>
          </div>

          <!-- Blog Card 3 -->
          <div class="bg-[#1c1c1c] rounded-3xl p-6 sm:p-8 transition-transform hover:scale-[1.02]">
            <div class="h-32 sm:h-40 bg-gradient-to-r from-yellow-500 to-orange-500 rounded-xl mb-4 sm:mb-6 flex items-center justify-center">
              <i class="fas fa-globe text-white text-3xl sm:text-4xl"></i>
            </div>
            <h3 class="text-white text-lg sm:text-xl font-medium mb-2 sm:mb-3">Как оплатить YouTube Premium</h3>
            <p class="text-gray-400 mb-4 sm:mb-6 text-sm sm:text-base">Узнайте, как оплатить подписку YouTube Premium с помощью Carddy.</p>
            <div class="flex justify-between items-center">
              <span class="text-gray-500 text-xs sm:text-sm">18 Апреля 2024</span>
              <router-link to="/youtube" class="px-3 sm:px-4 py-1 sm:py-1.5 rounded-full border border-blue-500 text-white hover:bg-blue-500/10 transition text-xs sm:text-sm">
                Читать
              </router-link>
            </div>
          </div>
        </div>

        <!-- Blog Cards Row 4 -->
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 mb-4 sm:mb-6">
          <!-- Blog Card 1 -->
          <div class="bg-[#1c1c1c] rounded-3xl p-6 sm:p-8 transition-transform hover:scale-[1.02]">
            <div class="h-32 sm:h-40 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-xl mb-4 sm:mb-6 flex items-center justify-center">
              <i class="fas fa-credit-card text-white text-3xl sm:text-4xl"></i>
            </div>
            <h3 class="text-white text-lg sm:text-xl font-medium mb-2 sm:mb-3">Как оплатить подписку Google</h3>
            <p class="text-gray-400 mb-4 sm:mb-6 text-sm sm:text-base">Узнайте, как оплатить подписку Google с помощью Carddy</p>
            <div class="flex justify-between items-center">
              <span class="text-gray-500 text-xs sm:text-sm">29 Марта 2024</span>
              <router-link to="/google" class="px-3 sm:px-4 py-1 sm:py-1.5 rounded-full border border-blue-500 text-white hover:bg-blue-500/10 transition text-xs sm:text-sm">
                Читать
              </router-link>
            </div>
          </div>

          <!-- Blog Card 2 -->
          <div class="bg-[#1c1c1c] rounded-3xl p-6 sm:p-8 transition-transform hover:scale-[1.02]">
            <div class="h-32 sm:h-40 bg-gradient-to-r from-green-500 to-teal-500 rounded-xl mb-4 sm:mb-6 flex items-center justify-center">
              <i class="fas fa-shield-alt text-white text-3xl sm:text-4xl"></i>
            </div>
            <h3 class="text-white text-lg sm:text-xl font-medium mb-2 sm:mb-3">Как оплатить Canva</h3>
            <p class="text-gray-400 mb-4 sm:mb-6 text-sm sm:text-base">Узнайте, как оплатить подписку Canva с помощью Carddy.</p>
            <div class="flex justify-between items-center">
              <span class="text-gray-500 text-xs sm:text-sm">7 Февраля 2024</span>
              <router-link to="/canva" class="px-3 sm:px-4 py-1 sm:py-1.5 rounded-full border border-blue-500 text-white hover:bg-blue-500/10 transition text-xs sm:text-sm">
                Читать
              </router-link>
            </div>
          </div>

          <!-- Blog Card 3 -->
          <div class="bg-[#1c1c1c] rounded-3xl p-6 sm:p-8 transition-transform hover:scale-[1.02]">
            <div class="h-32 sm:h-40 bg-gradient-to-r from-yellow-500 to-orange-500 rounded-xl mb-4 sm:mb-6 flex items-center justify-center">
              <i class="fas fa-globe text-white text-3xl sm:text-4xl"></i>
            </div>
            <h3 class="text-white text-lg sm:text-xl font-medium mb-2 sm:mb-3">Как оплатить Adobe</h3>
            <p class="text-gray-400 mb-4 sm:mb-6 text-sm sm:text-base">Узнайте, как оплатить подписку Adobe с помощью Carddy.</p>
            <div class="flex justify-between items-center">
              <span class="text-gray-500 text-xs sm:text-sm">16 Января 2024</span>
              <router-link to="/adobe" class="px-3 sm:px-4 py-1 sm:py-1.5 rounded-full border border-blue-500 text-white hover:bg-blue-500/10 transition text-xs sm:text-sm">
                Читать
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TheFooter />
    
    <!-- Modals -->
    <HowItWorksModal v-model="showHowItWorksModal" />
    <AskQuestionModal v-model="showAskQuestionModal" />
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, reactive, inject } from 'vue'
import FeatureCards from '@/components/FeatureCards.vue'
import ScrollingIcons from '@/components/ScrollingIcons.vue'
import TheHeader from '@/components/TheHeader.vue'
import TheFooter from '@/components/TheFooter.vue'
import HowItWorksModal from '@/components/HowItWorksModal.vue'
import AskQuestionModal from '@/components/AskQuestionModal.vue'
import SpecialOfferNotification from '@/components/SpecialOfferNotification.vue'
import SpecialNotificationUsers from '@/components/SpecialNotificationUsers.vue'

export default defineComponent({
  name: 'HomeView',

  components: {
    FeatureCards,
    ScrollingIcons,
    TheHeader,
    TheFooter,
    HowItWorksModal,
    AskQuestionModal,
    SpecialOfferNotification,
    SpecialNotificationUsers
  },




  setup() {
    const hostname = inject('hostname');
    const counter = ref(null)
    const showHowItWorksModal = ref(false)
    const showAskQuestionModal = ref(false)
    const showAlert = ref(true)
    console.log('inside setup ' + hostname);

    // SEO Meta Tags for Google and Yandex
    onMounted(() => {
      // Set page title
      document.title = 'carddy.tech - Оплата любых зарубежные сервисы онлайн из России в 2025';
      
      // Set meta description
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        document.head.appendChild(metaDescription);
      }
      metaDescription.content = 'Оплачивайте любые интернет-сервисы с помощью Carddy. Виртуальные карты для оплаты зарубежных сервисов с мгновенным выпуском.';
      
      // Set meta keywords
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.name = 'keywords';
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.content = 'виртуальные карты, оплата зарубежных сервисов, Carddy, онлайн платежи, виртуальная карта, зарубежные сервисы';
      
      // Set Open Graph meta tags (also used by Google)
      const ogTags = {
        'og:type': 'website',
        'og:url': 'https://carddy.tech/',
        'og:title': 'carddy.tech - Оплата любых зарубежные сервисы онлайн из России в 2025',
        'og:description': 'Оплачивайте любые интернет-сервисы с помощью Carddy. Виртуальные карты для оплаты зарубежных сервисов с мгновенным выпуском.',
        'og:image': '/images/carddy-og-image.jpg'
      };
      
      Object.entries(ogTags).forEach(([property, content]) => {
        let metaTag = document.querySelector(`meta[property="${property}"]`);
        if (!metaTag) {
          metaTag = document.createElement('meta');
          metaTag.setAttribute('property', property);
          document.head.appendChild(metaTag);
        }
        metaTag.content = content;
      });
      
      // Yandex-specific meta tags
      let yandexVerification = document.querySelector('meta[name="yandex-verification"]');
      if (!yandexVerification) {
        yandexVerification = document.createElement('meta');
        yandexVerification.name = 'yandex-verification';
        document.head.appendChild(yandexVerification);
      }
      yandexVerification.content = ''; // Add your Yandex verification code here
      
      // Set canonical URL
      let canonicalLink = document.querySelector('link[rel="canonical"]');
      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.rel = 'canonical';
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.href = 'https://carddy.tech/';

      // Mobile optimization meta tags
      let viewport = document.querySelector('meta[name="viewport"]');
      if (!viewport) {
        viewport = document.createElement('meta');
        viewport.name = 'viewport';
        document.head.appendChild(viewport);
      }
      viewport.content = 'width=device-width, initial-scale=1, maximum-scale=5';

      // Add FAQ Schema markup
      const faqSchema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        'mainEntity': faqQuestions.map(q => ({
          '@type': 'Question',
          'name': q.text,
          'acceptedAnswer': {
            '@type': 'Answer',
            'text': q.answer
          }
        }))
      };

      // Add schema markup to the page
      let script = document.querySelector('script[type="application/ld+json"]');
      if (!script) {
        script = document.createElement('script');
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(faqSchema);

      // Create sitemap.xml reference
      let sitemapLink = document.querySelector('link[rel="sitemap"]');
      if (!sitemapLink) {
        sitemapLink = document.createElement('link');
        sitemapLink.rel = 'sitemap';
        sitemapLink.type = 'application/xml';
        document.head.appendChild(sitemapLink);
      }
      sitemapLink.href = '/sitemap.xml';
    });

    const faqQuestions = reactive([
      { 
        text: 'Что такое Carddy?',
        isOpen: false,
        answer: 'Carddy — это ваш доступ к любым зарубежным сервисам с долларовым балансом. Сразу после активации вы можете оплачивать Midjourney, ChatGPT, Adobe и любые другие сервисы, где принимают доллары США'
      },
      { 
        text: 'Через какой банк проходят платежи?',
        isOpen: false,
        answer: 'Платежи обрабатываются через Sutton Bank по стандартам Visa — надёжно и без сбоев'
      },
      { 
        text: 'Какие сервисы я могу оплачивать через Carddy?',
        isOpen: false,
        answer: 'Любые зарубежные сервисы, принимающие онлайн-оплату в долларах США — Midjourney, ChatGPT, Adobe, Notion и сотни других.'
      },
      {
        text: 'Могу ли я сделать возврат?',
        isOpen: false,
        answer: 'Да, вы можете подать заявку на возврат средств через службу поддержки по почте info@carddy.ru. Мы рассматриваем обращения в течение 30 календарных дней. Возврат возможен, если карта не была выдана, выдана с ошибкой или не работает.'
      },
      // {
      //   text: 'Как долго действует виртуальная карта?',
      //   isOpen: false,
      //   answer: 'Карта действует 3 месяца.'
      // },
      // {
      //   text: 'Могу ли я пополнить баланс уже выпущенной карты?',
      //   isOpen: false,
      //   answer: 'К сожалению, баланс уже выпущенной карты пополнить нельзя, но вы всегда можете выпустить новую карту.'
      // },
      // {
      //   text: 'Могу ли я объединить баланс двух виртуальных карт?',
      //   isOpen: false,
      //   answer: 'Если на вашей карте осталось больше $10, мы можем выпустить для вас новую карту, объединив балансы.'
      // }
    ])
    
    const toggleFaq = (index) => {
      faqQuestions[index].isOpen = !faqQuestions[index].isOpen
    }
    
    onMounted(() => {
      
      // Add scroll animation observer
      const animateOnScroll = () => {
        const elements = document.querySelectorAll('.animate-fade-in-scroll')
        
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('opacity-100')
              entry.target.classList.remove('opacity-0', 'translate-y-10')
            }
          })
        }, { threshold: 0.1 })
        
        elements.forEach(element => {
          element.classList.add('opacity-0', 'translate-y-10', 'transition-all', 'duration-1000', 'ease-out')
          observer.observe(element)
        })
      }
      
      animateOnScroll()
    })
    
    return {
      hostname,
      counter,
      faqQuestions,
      toggleFaq,
      showHowItWorksModal,
      showAskQuestionModal,
      showAlert
    }
  },

  data() {
    return {
      i: 0,
      // input_sql: null,
      // user_meta_data: {
      //   browser:'',browser_name:'',browser_version:'',browser_ua:'',
      //   os:'',ip:'',page:'',url:'',user_id:0,session_hash:'',
      //   anonymous_id:0,anonymous_hash:'',session_status:0,
      // }
      count: 0,
      cards_counter: 0,
      usd_amount: "1.00",
      selected: 0,
      input_sql: {
        rub_amount: 0,
        usd_amount: 0,
        customer_id: 0,
        customer_email: "",
        card_id: 0,
      },
      input_fx: {
        rub_amount: 0,
        usd_amount: 100,
        customer_id: 0,
        customer_email: "",
        card_id: 0,
        user_id: 0,
        rub_amount_max_discount: 0,
        isPriceVolumeDiscounted: false,
        applyCarddyBalance: false,
        carddy_balance: 0,
        payment_type:'card',
      },
    };
  },

  created() {
    this.getOrdersCounter();


    if (this.$cookies.isKey("username_carddy")) {
      this.count = 1;
    }

    // this.generateRandom();
    // this.record_event();
  },

  mounted() {
    this.usdInputDiscount();
  },

  methods: {
    animateCounter() {
      // Add a simple counting animation for the counter
      const counterElement = this.$refs.counter;
      if (counterElement) {
        const finalValue = this.cards_counter;
        const duration = 2000; // 2 seconds
        const startValue = Math.max(this.cards_counter - 500, 0);
        const increment = finalValue - startValue;
        const startTime = performance.now();

        const updateCounter = (currentTime) => {
          const elapsedTime = currentTime - startTime;
          const progress = Math.min(elapsedTime / duration, 1);

          // Use easeOutExpo for a nice deceleration effect
          const easeOutExpo = 1 - Math.pow(2, -10 * progress);
          const currentValue = Math.floor(startValue + increment * easeOutExpo);

          counterElement.textContent = currentValue.toLocaleString();

          if (progress < 1) {
            requestAnimationFrame(updateCounter);
          }
        };

        requestAnimationFrame(updateCounter);
      }
    },

    async getOrdersCounter() {

      const rawResponse = await fetch(
          this.hostname + '/orders-counter', {
            method: 'GET',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json'
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
          });
      const responseJson = await rawResponse.json();
      console.log(responseJson);
      this.cards_counter = responseJson.cards_counter || 8999; // Fallback to 8999 if API returns no value
      
      // Start the counter animation after we have the value
      this.animateCounter();

    },

    // generateRandom() {
    //   this.random_number = Math.floor(Math.random() * 10) + 1; //Bettween 1 and 10
    //   console.log('generate random ' + this.random_number)
    // },
    // get_browser(val) {
    //   var browser = 'n/a';
    //
    //   if (val.isIE) {
    //     browser = 'IE';
    //   }
    //   if (val.isChrome) {
    //     browser = 'Chrome';
    //   }
    //   if (val.isFirefox) {
    //     browser = 'Firefox';
    //   }
    //   if (val.isOpera) {
    //     browser = 'Opera';
    //   }
    //   if (val.isSafari) {
    //     browser = 'Safari';
    //   }
    //   if (val.isEdge) {
    //     browser = 'Edge';
    //   }
    //   if (val.isChromeIOS) {
    //     browser = 'ChromeiOS';
    //   }
    //   if (val.isIOS) {
    //     browser = 'iOS';
    //   }
    //   this.user_meta_data.browser = browser;
    //   this.user_meta_data.browser_name = val.meta.name;
    //   this.user_meta_data.browser_version = val.meta.version;
    //   this.user_meta_data.browser_ua = val.meta.ua;
    // },
    //
    // get_url() {
    //
    //   this.user_meta_data.page = window.location.pathname;
    //   this.user_meta_data.url = window.location.href;
    // },
    //
    // record_event() {
    //
    //   var input_sql = {};
    //   // var axios_var_in = {};
    //
    //   console.log(' inside record_event ^ session_status ')
    //   console.log(this.detectBrowser);
    //
    //   this.get_browser(this.detectBrowser);
    //   this.get_url();
    //
    //   if (this.$cookies.isKey('access_token_carddy')) {
    //     this.axios({
    //       method: 'get',
    //       url: '' + this.hostname + '/is-token-valid?access_token=' + this.$cookies.get('access_token_carddy'),
    //     }).then((res) => {
    //       if (res.data.is_valid) {
    //         this.user_meta_data.session_status = 1;
    //         console.log('layout meta data');
    //         console.log(this.user_meta_data);
    //       } else {
    //         this.user_meta_data.session_status = 0
    //       }
    //     });
    //   } else {
    //     this.user_meta_data.session_status = 0
    //   }
    //
    //
    //
    //   if (this.user_meta_data.session_status === 0) {
    //
    //     console.log('inside if session_status = ');
    //
    //
    //     if (this.$cookies.isKey('anonymous_hash')) {
    //
    //       this.user_meta_data.anonymous_hash = this.$cookies.get('anonymous_hash');
    //       this.user_meta_data.anonymous_id = this.$cookies.get('anonymous_id');
    //
    //       if (this.$cookies.isKey('id_carddy')) {
    //         this.user_meta_data.user_id = this.$cookies.get('id_carddy');
    //       }
    //
    //       this.axios.get('https://www.cloudflare.com/cdn-cgi/trace')
    //           .then((res) => {
    //
    //             input_sql = {
    //               'browser': this.user_meta_data.browser,
    //               'browser_name': this.user_meta_data.browser_name,
    //               'browser_version': this.user_meta_data.browser_version,
    //               'browser_ua': this.user_meta_data.browser_ua,
    //               'os': this.user_meta_data.os,
    //               'ip': res.data,
    //               'page': this.user_meta_data.page,
    //               'url': this.user_meta_data.url,
    //               'user_id': this.user_meta_data.user_id,
    //               'session_hash': this.user_meta_data.session_hash,
    //               'anonymous_id': this.user_meta_data.anonymous_id,
    //               'anonymous_hash': this.user_meta_data.anonymous_hash,
    //               'session_status': this.user_meta_data.session_status,
    //               //'actionType': payload.actionType, 'clickedObjectId': payload.clickedObjectId
    //               'actionType': '',
    //               'clickedObjectId': ''
    //             };
    //
    //             console.log('Analytics data prepared:', !!input_sql);
    //
    //             // this.axios({
    //             //   method: 'post',
    //             //   url: '' + this.hostname + '/analytics/track-session',
    //             //   data: input_sql
    //             // }).then((res) => {
    //             //
    //             //
    //             //   //commit('record_session_event', axios_var_in);
    //             // });
    //           });
    //       //axios_var_in = {'axios_var': payload.axios_var, 'root_var': payload.root_var, 'input_sql': input_sql};
    //
    //
    //       //commit('record_session_event',axios_var_in);
    //
    //     } else {
    //
    //       this.axios.get(this.hostname + '/analytics/create-anonymous-user')
    //           .then((res) => {
    //             this.$cookies.set('anonymous_hash', res.data.anonymous_hash);
    //             this.$cookies.set('anonymous_id', res.data.anonymous_id);
    //
    //             if (this.$cookies.isKey('id_carddy')) {
    //               this.user_meta_data.user_id = this.$cookies.get('id_carddy');
    //             }
    //
    //             this.axios.get('https://www.cloudflare.com/cdn-cgi/trace')
    //                 .then((resip) => {
    //                   input_sql = {
    //                     'browser': this.user_meta_data.browser,
    //                     'browser_name': this.user_meta_data.browser_name,
    //                     'browser_version': this.user_meta_data.browser_version,
    //                     'browser_ua': this.user_meta_data.browser_ua,
    //                     'os': this.user_meta_data.os,
    //                     'ip': resip.data,
    //                     'page': this.user_meta_data.page,
    //                     'url': this.user_meta_data.url,
    //                     'user_id': this.user_meta_data.user_id,
    //                     'session_hash': this.user_meta_data.session_hash,
    //                     'anonymous_id': res.data.anonymous_id,
    //                     'anonymous_hash': res.data.anonymous_hash,
    //                     'session_status': this.user_meta_data.session_status,
    //                     'actionType': '',
    //                     'clickedObjectId': ''
    //                   };
    //
    //                   // this.axios({
    //                   //   method: 'post',
    //                   //   url: '' + this.hostname + '/analytics/track-session',
    //                   //   data: input_sql
    //                   // }).then((res) => {
    //                   //
    //                   //
    //                   //   //commit('record_session_event', axios_var_in);
    //                   // });
    //                 });
    //           });
    //     }
    //
    //
    //     //commit('update_session_status', 1);
    //
    //     // console.log(' inside if ^ session_status ' + state.session_status)
    //     //console.log(input_sql)
    //   } else {
    //
    //     console.log('inside else session_status ');
    //     //console.log(' session_hash ' +state.session_hash);
    //
    //     if (this.$cookies.isKey('id_carddy')) {
    //       this.user_meta_data.user_id = this.$cookies.get('id_carddy');
    //     }
    //
    //     this.axios.get('https://www.cloudflare.com/cdn-cgi/trace')
    //         .then((resip) => {
    //
    //           input_sql = {
    //             'browser': this.user_meta_data.browser,
    //             'browser_name': this.user_meta_data.browser_name,
    //             'browser_version': this.user_meta_data.browser_version,
    //             'browser_ua': this.user_meta_data.browser_ua,
    //             'os': this.user_meta_data.os,
    //             'ip': resip.data,
    //             'page': this.user_meta_data.page,
    //             'url': this.user_meta_data.url,
    //             'user_id': this.user_meta_data.user_id,
    //             'session_hash': this.user_meta_data.session_hash,
    //             'anonymous_id': this.user_meta_data.anonymous_id,
    //             'anonymous_hash': this.user_meta_data.anonymous_hash,
    //             'session_status': this.user_meta_data.session_status,
    //             //'actionType': payload.actionType, 'clickedObjectId': payload.clickedObjectId
    //             'actionType': '',
    //             'clickedObjectId': ''
    //           };
    //
    //           // this.axios({
    //           //   method: 'post',
    //           //   url: '' + this.hostname + '/analytics/track-session',
    //           //   data: input_sql
    //           // }).then((res) => {
    //           // });
    //
    //         });
    //
    //     // commit('record_session_event',axios_var_in);
    //
    //     //console.log(input_sql)
    //
    //   }
    //
    //
    // },

    async usdInput() {

      this.input_sql.usd_amount =
          Number(parseFloat(this.usd_amount).toFixed(2)) * 100;

      const rawResponse = await fetch(this.hostname + "/fx/get-usd", {
        method: "GET",
      });
      const responseJson = await rawResponse.json();
      console.log(
          "inside fx usdInput " +
          this.selected +
          " " +
          responseJson +
          " " +
          this.usd_amount
      );
      this.input_sql.rub_amount =
          Number(
              (parseFloat(this.usd_amount) * parseFloat(responseJson)).toFixed(2)
          ) ;
    },


    async usdInputDiscount() {
      this.input_sql.user_id = Number.parseInt(this.$cookies.get("id_carddy"));
      this.noLoading = true;


      const rawResponse = await fetch(
          this.hostname + "/fx-usd-rub-with-referral-discount",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(this.input_fx),
          }
      );
      const responseJson = await rawResponse.json();

      console.log(responseJson);

      this.input_sql.rub_amount =
          Number(
              (parseFloat(this.usd_amount) * parseFloat(responseJson.price) / 100).toFixed(2)
          ) ;

    },
  }
})
</script>

<style scoped>
.blinking-cursor {
  animation: blink 1s step-end infinite;
}

@keyframes blink {
  from, to { opacity: 1; }
  50% { opacity: 0; }
}
</style>
